<template>
  <li class="treeview" :class="{active : treeviewDisp}">  
    <a @click="toggleTreeview(module)" class="cursor-pointer">
      <i class="fa" :class="moduleObj.icon"></i> 
      <span>{{ moduleObj.name[nowLang] }}</span>
      <i class="fa fa-angle-left pull-right"></i>
    </a>
    <ul class="treeview-menu" :class="{ 'menu menu-open' : currModule == module }">
      <template v-for="(menus, menutype) in moduleObj.codapp">
        <template v-if="menutype != 'dashboard'">
          <template v-if="menus.length > 0 && true">
            <li class="treeview submenu-header">
              <div class="label-submenu-header">
                <i class="fa" :class="fontIcon[menutype]"></i> 
                <span class="text">{{ menu[menutype][nowLang] }}</span>
              </div>
            </li>
            <template v-for="(codapp, key) in menus">
             <template v-if="true">
              <li class="border-color-skin" :class="{ active: currCodapp == codapp }" style="border-left: 1px solid;">
                <template v-if="$router.match(codapp).name !== '404'">
                    <router-link :to="{ name: codapp }" @click.native="closeSidebarMobile()">
                      <i class="codapp-icon fa" :class="{'fa-circle': currCodapp == codapp,   'fa-circle-o': currCodapp != codapp }"></i> 
                      <span class="codapp-text">{{ descCodapp(moduleObj, codapp) }}</span>
                    </router-link>
                </template>
              </li>
             </template>
            </template>
          </template>
        </template>
        <template v-else>
          <template v-if="version >= '2.0.0' || moduleObj.type == 'mss'">
            <template v-if="moduleObj.codapp_permis">
              <li class="submenu-header header-dashboard" :class="{ active: currModule == module }">
                <router-link :to="{ name: module }" @click.native="closeSidebarMobile()">
                  <i class="fa" :class="fontIcon[menutype]"></i> 
                  <span class="text">{{ menu[menutype][nowLang] }}</span>
                  <i class="fa fa-star text-white pull-right icon-hover"></i>
                </router-link>
              </li>
            </template>
          </template>
        </template>
      </template>
    </ul>
  </li>
</template>

<script>
export default {
  name: 'dash-sidebar-menu',
  props: [ 'moduleObj', 'module', 'currModule', 'nowLang', 'menuRequest', 'menuApprove', 'fontIcon', 'currCodapp', 'menu', 'rescale', 'version', 'pcDisp', 'closeSidebarMobile' ],
  data () {
    return {
      treeviewDisp: false
    }
  },
  methods: {
    toggleTreeview (module) {
      this.treeviewDisp = !this.treeviewDisp
      this.rescale()
    },
    descCodapp (module, codapp) {
      return (typeof module['codapp_permis'][codapp] !== 'undefined') ? module['codapp_permis'][codapp][this.nowLang] : ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// DashSidebarMenu.vue?510409c7